<template>
    <div class="ui stackable grid entity_form transition transition"
        @keypress.enter="$bus.$emit(eventbus.update_core_waybill.name)">
        <div
            v-bind:class="{
                'seven wide column': !is_grid_table_style,
                'eight wide column': is_grid_table_style,
            }">
            <div class="ui segment">
                <div class="ui top attached green label">
                    <h5>寄件人</h5>
                </div>
                <div>
                    <SimpleFormItem
                        v-for="(field_name, index) in ['sender_company_name','sender_name','sender_zip_code','sender_address','sender_email','sender_url','sender_phone','sender_fax']"
                        :key="field_name+'simple_form_item'"
                        :core_waybill="core_waybill"
                        :field_name="field_name"
                    >
                    </SimpleFormItem>
                </div>
            </div>
            <div class="ui segment">
                <div class="ui top attached green label">
                    <h5>收件人</h5>
                </div>
                <div>
                    <SimpleFormItem
                        v-for="(field_name, index) in [
                            'consignee_company_name',
                            'consignee_name',
                            'consignee_zip_code',
                            'consignee_address',
                            'consignee_phone',
                            'consignee_email',
                            'consignee_fax',
                        ]"
                        :key="field_name+'simple_form_item'"
                        :core_waybill="core_waybill"
                        :field_name="field_name"
                    >
                    </SimpleFormItem>

                </div>
            </div>
            <div class="ui segment">
                <div class="ui top attached green label">
                    <h5>超商資訊</h5>
                </div>
                <div>
                    <SimpleFormItem
                        v-for="(field_name, index) in [
                            'cvs_store_number',
                            'cvs_store_name',
                            'cvs_store_address',
                            'cvs_store_phone'
                        ]"
                        :key="field_name+'simple_form_item'"
                        :core_waybill="core_waybill"
                        :field_name="field_name"
                    >
                    </SimpleFormItem>

                </div>
            </div>
            <div class="ui segment">
                <div class="ui top attached label">
                    <h5>貨物圖片</h5>
                </div>
                <div style="padding:4px 0;">
                    <div v-for="(field_name, index) in ['goods_file_url','goods_file_url_2','goods_file_url_3']"
                        :key="field_name+'simple_form_item'"
                        style="padding: 4px 0px;">
                        <label>
                            {{ $t("models.attributes.core_waybills."+field_name) }}
                        </label>
                        <img v-if="core_waybill[field_name]"
                            :src="core_waybill[field_name]"
                            style="max-width:100%;"
                        />
                        <div
                            v-else
                            class="ui message" style="margin: 0; padding: 10px 12px;">
                            <!-- 無上傳圖片 -->
                            {{ $t('ui.pages.core_waybills.no_upload_any_picture') }}
                        </div>
                    </div>
                    <br>
                    <div v-if="is_show_receipt_file">
                        <label>
                            {{ $t("models.attributes.core_waybills.receipt_file") }}
                        </label>
                        <FormFileUploader
                            :is_can_update_field="is_can_update_field('receipt_file_url')"
                            :core_waybill="core_waybill"
                            :eventbus="eventbus"
                        ></FormFileUploader>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-bind:class="{
                'six wide column': !is_grid_table_style,
                'eight wide column': is_grid_table_style,
            }">
            <div class="ui segment">
                <div class="ui top attached orange label">
                    <h5>貨物資訊</h5>
                </div>

                <div style="padding:4px 0;">
                    <label>
                        {{ $t("models.attributes.core_waybills.intermodal_contract_number") }}
                    </label>
                    <div class="ui mini fluid action input">
                        <input type="text" v-model="core_waybill.intermodal_contract_number">
                        <a class="ui button" @click="process_intermodal()">
                            <!-- 執行聯運 -->
                            {{ $t("ui.pages.core_waybills.perform_intermodal") }}
                        </a>
                    </div>
                </div>

                <SimpleFormItem
                    v-for="(field_name, index) in [
                        'tracking_number',
                        'original_number',
                        'original_number_2',
                        'return_number',
                        'storage_number',
                        'warehouse_identity',
                        'operation_number',
                        'flight_number',
                        'goods_name',
                        'collection',
                        'tax',
                        'declared_value',
                        'weight_in_kilo',
                        'length_in_cm',
                        'width_in_cm',
                        'height_in_cm',
                        'measurement'
                    ]"
                    :key="field_name+'simple_form_item'"
                    :core_waybill="core_waybill"
                    :field_name="field_name"
                >
                </SimpleFormItem>
            </div>

            <div class="ui segment">
                <div class="ui top attached orange label">
                    <h5>配送資訊</h5>
                </div>

                <div style="padding:4px 0;">
                    <label>
                        {{ $t("models.attributes.core_waybills.payment_type") }}
                    </label>
                    <div v-if="is_can_update_field('payment_type')"
                        class="ui fluid input">
                        <select
                            class="ui fluid dropdown"
                            v-dropdown
                            v-model="core_waybill.payment_type">
                            <option value="">{{ $t('ui.general.please_select') }}</option>
                            <option v-for="payment_type in core_waybill_payment_types"
                                :value="payment_type.value">
                                {{ payment_type.name }}
                            </option>
                        </select>
                    </div>
                    <div v-else
                        style="margin: 0; padding: 6px 12px;"
                        class="ui message">
                        {{ core_waybill.payment_type || $t('ui.general.please_select') }}
                    </div>

                    <label>
                        {{ $t("models.attributes.core_waybills.label_type") }}
                    </label>
                    <div class="ui fluid input">
                        <select @change="$forceUpdate()" class="ui fluid dropdown label_type"
                            v-dropdown v-model="core_waybill.label_type">
                            <option value="">{{ $t('ui.general.please_select') }}</option>
                            <option
                                v-for="label_info in papers_label_infos"
                                :value="`Label::${label_info.name}`"
                                >
                                {{ get_printing_type(label_info) }}
                            </option>
                            <!-- <option value="Label::Default">TW568預設</option>
                            <option value="Label::ByExpress" v-if="$store.state.provider.node.code == 'BY'">博宇速運</option>
                            <option value="Label::ChangQing" v-if="$store.state.provider.node.code == 'CQF'">長慶運通</option>
                            <option value="Label::FlyCargo" v-if="$store.state.provider.node.code == 'FR'">飛樂航空</option>
                            <option value="Label::KerryTJ">嘉里大榮</option>
                            <option value="Label::KerryTJNew">嘉里大榮(新)</option>
                            <option value="Label::HCT">新竹物流</option>
                            <option value="Label::HCTInvoice">新竹物流含發票</option>
                            <option value="Label::TCat">統一速達</option>
                            <option value="Label::Pelican">宅配通</option>
                            <option value="Label::Presco">統一超商</option>
                            <option value="Label::PrescoInvoice">統一超商含發票</option>
                            <option value="Label::FamilyMart">全家便利商店</option>
                            <option value="Label::FamilyMartNew">全家便利商店(新)</option>
                            <option value="Label::FamilyMartInvoice">全家便利商店含發票</option> -->
                        </select>
                    </div>

                    <div class="ui two column grid" style="margin-bottom: 0px;">
                        <div class="column">
                            <label>
                                {{ $t("models.attributes.core_waybills.is_collected") }}
                            </label>
                            <div class="ui slider checkbox" v-if="is_can_update_field('is_collected')">
                                <input type="checkbox" id="is_collected" v-model="core_waybill.is_collected">
                                <label class="pointer" for="is_collected">
                                    {{
                                        (core_waybill.is_collected)
                                            ? $t("models.attributes.core_waybills.paid")
                                            : $t("models.attributes.core_waybills.no_paid")
                                    }}
                                </label>
                            </div>
                            <span v-else>
                                ：{{
                                    (core_waybill.is_collected)
                                        ? $t("models.attributes.core_waybills.paid")
                                        : $t("models.attributes.core_waybills.no_paid")
                                }}
                            </span>
                        </div>
                    </div>
                    <br>

                    <SimpleFormItem
                        v-for="(field_name, index) in [
                            'shipping_period'
                        ]"
                        :key="field_name+'simple_form_item'"
                        :core_waybill="core_waybill"
                        :field_name="field_name">
                    </SimpleFormItem>

                    <div style="padding: 4px 0px;">
                        <label>
                            {{ $t("models.attributes.core_waybills.shipping_date") }}
                        </label>

                        <el-date-picker
                            v-if="is_can_update_field('shipping_date')"
                            v-model="core_waybill.shipping_date"
                            :format="'yyyy-MM-dd'"
                            type="date"
                            style="width:100%;"
                            :placeholder="$t('ui.el.datepicker.selectDateTime')">
                        </el-date-picker>
                        <div
                            v-else
                            class="ui message" style="margin: 0; padding: 10px 12px;">
                            {{ core_waybill.shipping_date || $t('ui.general.no_data') }}
                        </div>
                    </div>

                    <SimpleFormItem
                        v-for="(field_name, index) in [
                            'note',
                            'note_2',
                            'note_3',
                            'shipping_note',
                        ]"
                        :key="field_name+'simple_form_item'"
                        :core_waybill="core_waybill"
                        :field_name="field_name">
                    </SimpleFormItem>
                </div>
            </div>

            <div class="ui segment">
                <div class="ui top attached label">
                    <h5>其他費用</h5>
                </div>

                <SimpleFormItem
                    v-for="(field_name, index) in [
                        'collection_fee',
                        'simplified_declaration_form_fee',
                        'declaration_form_fee',
                        'declaration_form_extra_fee',
                        'tax',
                        'price',
                        'insurance',
                        'material_fee',
                        'consignee_tax_point',
                        'sender_tax_point',
                        'warehouse_fee',
                        'fuel_surcharge',
                        'value_added_service_fee',
                        'overlength_fee',
                        'overweight_fee',
                        'extra_fee',
                    ]"
                    :key="field_name+'simple_form_item'"
                    :core_waybill="core_waybill"
                    :field_name="field_name"
                    :input_type="'number'">
                </SimpleFormItem>
            </div>
        </div>
    </div>
</template>

<script>
import SimpleFormItem from "./simple_form_item.vue"
import FormFileUploader from "./form_file_uploader.vue"

export default {
    props: {
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
        core_waybill: {
            default: {},
            type: Object
        },
        is_show_receipt_file: {
            default: false,
            type: Boolean
        },
        is_can_update: {
            default: false,
            type: Boolean
        },
        can_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        cant_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        focus_field_field_name: {
            default: "",
            type: String
        },
    },
    data() {
        return {
            is_grid_table_style: false,
        }
    },
    created() {
    },
    mounted() {
        // 暫時移除未填入欄位 全部開啟 grid_table_style

        // if ($(window).width() < 1200) {
        //     this.is_grid_table_style = true;
        // }
        //
        // $(window).resize(() => {
        //     var wdth = $(window).width();
        //
        //     if (this.is_grid_table_style == false && wdth < 1200) {
        //         this.is_grid_table_style = true;
        //     } else if(this.is_grid_table_style == true && wdth >= 1200) {
        //         this.is_grid_table_style = false;
        //     }
        // });
        this.is_grid_table_style = true
    },
    computed: {
        core_waybill_payment_types() {
            return this.$store.state.provider.tool_core_waybill_module.core_waybill_payment_types;
        },
        papers_label_infos() {
            return this.$store.state[this.$store.state.current_scope].papers_label_infos || {}
        },
    },
    methods: {
        get_printing_type(label_info) {
            let note = ""
            let result = this.$t('ui.toolbox.core_waybills_label_svg.printing_types["Label::' + label_info.name+ '"]')
            if (label_info.style) {
                if (label_info.style.height != 100 || label_info.style.width != 100) {
                    note = ` (${label_info.style.height}x${label_info.style.width}mm)`
                }
            }
            return result + note
        },
        process_intermodal() {
            var rest_url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill_process_intermodal);
            var url = rest_url.parse(
                {
                    core_waybill_identity: this.core_waybill.identity
                }
            );

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.$noty.success("聯運成功");
                })
                .catch(error => {
                    this.$noty.error("聯運失敗");
                });
        },
        /*
         * ========================================================================
         * $parent
         * ========================================================================
         */
        is_can_update_field(field_name = "") {
            return this.$parent.is_can_update_field(field_name);
        },
        is_lock_field(value) {
            /*
                更新全運單欄位 :is_can_update="true"
                反轉，只更新運單部份欄位
                    :is_can_update="true"
                    :can_update_field_names="['number', '...']"
                更新運單但鎖部份欄位
                    :is_can_update="true"
                    :cant_update_field_names="['number', '...']"

                can_update_field_names > cant_update_field_names
            */
            if (!this.is_can_update) {
                return true
            }

            if (this.is_can_update && !this.can_update_field_names.length && !this.cant_update_field_names.length) {
                return false
            }

            if (this.can_update_field_names.length) {
                var reslut = _.findIndex(this.can_update_field_names, (name) => {
                    return name == value
                })
                return (reslut == "-1") ? false : true
            }

            if (this.cant_update_field_names.length) {
                var reslut = _.findIndex(this.cant_update_field_names, (name) => {
                    return name == value
                })
                return (reslut == "-1") ? true : false
            }
            return true
        },
    },
    components: {
        SimpleFormItem,
        FormFileUploader,
    },
}
</script>

<style scoped lang="scss">
    @import "./.assets/stylesheets/easy_form.scss";

    .ui.slider.checkbox input:checked~.box:before,
    .ui.slider.checkbox input:checked~label:before {
        background-color: #2185d0 !important;
    }
</style>
